import { useQRCode } from 'next-qrcode'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'

import Image from '@/components/Image'
import { LINKS } from '@/constants/links'
import { useAmplitude } from '@/contexts/AmplitudeProvider'
import { getDeviceId } from '@/services/amplitude/getDeviceId'
import { getAllExperimentsAndVariants } from '@/utils/getAllExperimentsAndVariants'
import { getGaClientId } from '@/utils/getGaClientId'
import { getGASessionId } from '@/utils/getGASessionId'
import { handleAppUtmDynamicUrl } from '@/utils/handleAppUtmUrl'

import styles from '../../Header.module.css'

type DownloadAppMenuProps = {
  useMenuStyle?: boolean
}

const DownloadAppMenu: React.FC<DownloadAppMenuProps> = ({
  useMenuStyle = true
}) => {
  const { Canvas } = useQRCode()
  const [utmUrl, setUtmUrl] = useState(LINKS.APP_LINK_HEADER)
  const { analytics } = useAmplitude()
  const router = useRouter()

  useEffect(() => {
    const updatedUrl = handleAppUtmDynamicUrl(LINKS.APP_LINK_HEADER)
    setUtmUrl(updatedUrl)
  }, [])

  function trackAnalyticsEvent(e: {
    nativeEvent: unknown
    currentTarget: { href: string }
  }) {
    const textSection = (e.nativeEvent as unknown as { section: string })
      .section

    const textButton = (
      e.nativeEvent as unknown as {
        clicktext: string
      }
    ).clicktext

    const ctaReference = `Sub menu | Baixe o App | ${textButton}`

    analytics?.track({
      event_type: 'cta ton',
      event_properties: {
        name: 'cta ton',
        section_reference: textSection,
        cross_lead_id: getGASessionId(),
        client_id_ga: getGaClientId(),
        user_agent: window?.navigator?.userAgent,
        category: `${e.currentTarget.href}`,
        cta_reference: ctaReference,
        source: router.pathname,
        experiments: JSON.stringify(getAllExperimentsAndVariants())
      },
      device_id: getDeviceId(),
      user_agent: window?.navigator?.userAgent
    })
  }

  return (
    <div className={`${useMenuStyle ? styles.menu : ''} right-0 py-24`}>
      <div className="flex flex-col items-center p-16">
        <p className="mb-16 font-medium">
          Escaneie com a câmera do seu celular:
        </p>
        <Canvas
          text={utmUrl}
          options={{
            margin: 0,
            scale: 4,
            width: 160
          }}
        />
      </div>
      <hr className="my-8 bg-display-200" />
      <div className="flex flex-col items-center p-16">
        <p className="mb-8 font-medium">Ou acesse abaixo:</p>
        <div className="flex gap-8">
          <a
            href="https://play.google.com/store/apps/details?id=br.com.stone.ton"
            target="_blank"
            rel="noreferrer"
            onClick={(e) => {
              trackAnalyticsEvent(e)
            }}
          >
            <Image
              src="ton-cms/prd/googleplay_35a9efbf7b.webp"
              alt="Disponível no GooglePlay"
              width={152}
              height={44}
              className="max-w-full h-auto"
            />
          </a>
          <a
            href="https://apps.apple.com/us/app/ton/id1496404455?l=pt&ls=1"
            target="_blank"
            rel="noreferrer"
            onClick={(e) => {
              trackAnalyticsEvent(e)
            }}
          >
            <Image
              src="ton-cms/prd/appstore_4a448c7865.webp"
              alt="Disponível na App Store"
              width={152}
              height={44}
              className="max-w-full h-auto"
            />
          </a>
        </div>
      </div>
    </div>
  )
}

export default DownloadAppMenu
